export default __webpack_public_path__ + "b71bf35.png";